import { SWReactIcons } from "@similarweb/icons";
import { SimpleDropdownItem } from "@similarweb/ui-components";
import styled, { css } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

export const StyledEnrichmentDropdown = styled.div<{ disabled: boolean }>`
    display: flex;
    cursor: pointer;
    position: relative;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.3;
        `}
`;

export const StyledEnrichmentOption = styled(SimpleDropdownItem)`
    padding: 17px;
    display: flex;
    align-items: center;
    text-indent: 0;
    cursor: pointer;
    height: auto;

    & .itemIcon {
        margin-right: 11px;
    }

    ${setFontVariant("body2", colorsPalettes.carbon[500])}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.3;
        `}
`;

export const IconWrapper = styled(SWReactIcons)`
    &.blue {
        & path {
            fill: ${colorsPalettes.blue[400]};
        }
    }
`;
